import { paymentList } from '@/common/demand'

/**
 * 付款信息转换
 * @param {Number|String} type
 */
export default function parsePayment(type) {
  return (paymentList.find(item => item.value === Number(type)) || {}).label || '-'
}
